import Vue from 'vue';
import '@fortawesome/fontawesome-free/css/all.css';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Vue2Editor from 'vue2-editor';
import Vuetify from 'vuetify';
import { VTooltip } from 'vuetify/lib';
import { types } from '@/store/rootTypes';
import { getFirebaseAuth } from '@/shared/firebase/firebase';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import './vee-validate';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import { reloadLanguage } from '@/tools/language';
import { injectStore } from './shared/store/init';
import i18n from './i18n';
import './moment';
import router from './router/router';
import store from './store';
import App from './App';
import './bugsnag';
import LoadingDialog from './components/dialogs/LoadingDialog';
import 'editor-svelte';
import 'editor-svelte/dist/style.css';

Vue.use(PerfectScrollbar);

injectStore(store, types);

// TODO find a better way to include image from node_modules (maybe from webpack config)
// eslint-disable-next-line import/no-unresolved
require('@/assets/images/code/code.png');

VTooltip.options.props.openDelay.default = 333;
Vue.config.productionTip = false;
Vue.use(Vuetify);
Vue.use(vue2Dropzone);
Vue.use(Vue2Editor);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('LoadingDialog', LoadingDialog);

new Vue({
  i18n,
  router,
  store,
  vuetify: new Vuetify({
    theme: {
      themes: {
        light: {
          background: '#f6f5fa',
          debug: '#f0f',
          'fake-white': '#fcfcfc',
          primary: '#3F47CD',
          secondary: '#03a9f4',
          accent: '#3f51b5',
          danger: '#f44336',
          gray: '#a5a5a5',
          error: '#f44336',
          warning: '#ff9800',
          info: '#607d8b',
          success: '#4caf50',
        },
      },
    },
    icons: {
      iconfont: 'fa',
      comments: 'fas fa-comments',
      file_word: 'far fa-file-word',
      file_pdf: 'far fa-file-pdf',
      file_excel: 'far fa-file-excel',
      file_powerpoint: 'far fa-file-powerpoint',
      file_unknown: 'far fa-file-alt',
      gem: 'fas fa-gem',
      newspaper: 'far fa-newspaper',
      sitemap: 'fas fa-sitemap',
      thumbtack: 'fas fa-thumbtack',
      thumbtack_outlined: 'far fa-thumbtack',
    },
  }),
  created() {
    reloadLanguage();
    getFirebaseAuth().onIdTokenChanged(async user => {
      if (user) {
        await store.dispatch(types.authentication.actions.login, user);
      }
    });
    store.dispatch(types.featureSwitches.actions.initFeatureSwitches, process.env);
    console.log(`
              .t8@8@tX XX8%@;.
         ..;X@8X 8@.8 :88  S:8tX:.
        :X8:;8@ 8X 8:8@:8 8:@8 .X@
       t8.8 8@ 8.;8:%@888@8@88;@@8:
     .@X.888.;8:8t88888X8@8@.8 :X:
    ;@ .88888.;8.8@@.@8@.888888.:      .
   :S 8S 8 8 8@ 888888888888888X      :%.
  .X :@ 8:t8X.88.88888.88X8X8@8;     :@X8:
  %X@@ 888@.88X 8 8@@.88t88@88%     t8 .St
  8 8@;X ;8X8.8 88;8t..t88@88%.    tX88X:.
  8:8 8 8S8@@88 8@. .;8888X8t    .@ 88:t88
  %8 @8:88.8S%%.. .t8@@8X88.  ..XS8  88 .8
  %@:@@88 @%    . XS888S8t.  .t8@@ 8@..8@@
  8888@888;     :8@88S88. .:S8888 8;t8X;8@
  8 .8. 8.     SX8@ 8St.;@@@88888.t8S:t8Xt
  %8X.%8:    .% 8 X..;@8X@88888@.88 ;8;.88
  :% S8;    .t8S 8888@8888888@:@:X@@X.88..
   X88:    .% 8@888888888@ ;8:8;88X8@:8S:
   :;.     .8@8@888888888888:t@8@ .8:88%:
          .88 8888888 8:8 @88S.888S.8XX
          S .888.@:@ 8.@8@8@8@8X :8S8%
          S@X.t8X.88 X8@8@ ;8 8 888X;
          %8888:.88 8 8 8 8@.88S8@:
          .%.t88t8@888@88@S888X;.

  ----------------------------------------

        #     #
        ##    #  ####   ####   ####
        # #   # #    # #    # #
        #  #  # #    # #    #  ####
        #   # # #    # #    #      #
        #    ## #    # #    # #    #
        #     #  ####   ####   ####
`);
  },
  render: h => h(App),
}).$mount('#app');
